import { useEffect } from 'react';
import tw from 'twin.macro';

import { Navigate, useLocation } from 'react-router-dom';

import ConfigurationTabs from './components/ConfigurationTabs';
import PositionsTab from './components/positions/PositionsTab';
import TemplatesTab from './components/templates/TemplatesTab';

const Configuration = () => {
  const location = useLocation();

  if (location.pathname === '/backoffice/configuration') {
    return <Navigate to="/backoffice/configuration/positions" replace />;
  }

  const isPositionsTab = location.pathname.startsWith('/backoffice/configuration/positions');

  return (
    <div tw="m-auto flex min-h-screen flex-col space-y-5 px-4 py-6 lg:(px-20 py-14)">
      <div>
        <h4 tw="text-gray-900 font-semibold">ตั้งค่า</h4>
        <p tw="text-gray-500 text-sm mt-1">จัดการตำแหน่งงานและชุดคำถามสำหรับการสัมภาษณ์</p>
      </div>
      <div tw="rounded-xl border border-gray-200 bg-white overflow-hidden">
        <ConfigurationTabs />
        <div tw="p-6">
          {isPositionsTab ? <PositionsTab /> : <TemplatesTab />}
        </div>
      </div>
    </div>
  );
};

export default Configuration;
